import React from 'react';

const radio = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	let dispContent = fieldDetail.options.map((arr,i) => {
		return <input type="radio" name={props.fieldKey} value={fieldDetail.value} key={i}  onChange={props.changed}/>;
	});
	return (
	        <div className="form-group">
	          <label className="pl-0">{fieldDetail.title}</label><br/>           
	          {dispContent}
	       	</div> 
	);
}

export default radio;